import { ShipmentHeader } from '../../models/shipment-header';
import { ShipmentQuery } from '../../models/shipment-query';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';
import { ShipmentView } from '../../models/shipment-view';
import { selectShipmentViews } from '../profile/profile.state';
import { objectEqual } from '../../utils/object-equal';
import { shipmentQueryEqual } from '../../utils/shipment-query-equal';

export interface ShipmentsTableState {
    query: ShipmentQuery;
    page: ShipmentHeader[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
    columns: string[];
    updatingShipments: string[];
}

export const selectShipmentsTableState = (state: AppState) => state.shipmentsTable;

export const selectShipmentsTableQuery = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.query);

export const selectShipmentsTablePage = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.page);

export const selectShipmentsTableBusy = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.busy);

export const selectShipmentsTableCount = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.totalCount);

export const selectShipmentsTableSelection = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.selection);

export const selectShipmentsTableColumns = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.columns);

export const selectShipmentsTableSelectedHeaders = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.page.filter((h) => state.selection.indexOf(h.id) !== -1));

export const selectShipmentsTableAsView = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => ({
        id: null,
        caption: null,
        query: { ...state.query },
        columns: [ ...state.columns ],
        hide: false
    }));

function compareViewToState(state: ShipmentsTableState, view: ShipmentView): boolean {
    return shipmentQueryEqual(state.query, view.query) && objectEqual(state.columns, view.columns) && !view.hide;
}

export const selectShipmentsCurrentView = createSelector(selectShipmentsTableState, selectShipmentViews,
    (state: ShipmentsTableState, views: ShipmentView[]) =>
        views.find(v => compareViewToState(state, v))?.id || null
);

export const selectShipmentViewMenu = createSelector(selectShipmentsTableState, selectShipmentViews,
    (state: ShipmentsTableState, views: ShipmentView[]) => views.map((view) => ({
        id: view.id, caption: view.caption, selected: compareViewToState(state, view)
    })));

export const selectShipmentsUpdating = createSelector(selectShipmentsTableState,
    (state: ShipmentsTableState) => state.updatingShipments);

